
$(document).on("click",'.Mobile_nav_trigger input',function() {
    // alert();
    // $('.Mobile_header_overlay').addClass('active');
    if ($('.Mobile_header_nav_outer').hasClass('active')){
        $('.Mobile_header_nav_outer').removeClass('active');
    }
    else{
        setTimeout(function(){
            $('.Mobile_header_nav_outer').addClass('active');
        },100);
    }
    
    $('body').addClass('Overflow_hidden');
    $('.Mobile_header_nav_outer.Mobile_only').toggle();
});  

// $('.mb_header_close').click(function(){
//     $('.Mobile_header_overlay').removeClass('active');
//     $('.Mobile_header_nav_outer').removeClass('active');
//     $('body').removeClass('Overflow_hidden');
// });

$('.has_child_items_js').mouseover(function(){
    $('.Header_menu_child_container_outer').slideDown();
});

$('.not_has_child_items_js').mouseover(function(){
    $('.Header_menu_child_container_outer').slideUp();
});

$('.Header_menu_child_container_outer').mouseleave(function() {
    // $('.Header_menu_child_container_outer').slideUp();
    // Get the ".has_child_items_js" element
    const hasChildItemsElement = $('.has_child_items_js');

    // Check if the mouse is currently over the ".has_child_items_js" element
    if (hasChildItemsElement.is(':hover')) {
        return; // Do nothing if the mouse is over ".has_child_items_js"
    }

    // If the mouse is not over ".has_child_items_js", slide up the ".Header_menu_child_container_outer" element
    $('.Header_menu_child_container_outer').slideUp();
});

$('.mobile_has_child_items').click(function(){
    $('.Mobile_main_item').removeClass('active');
    $(this).toggleClass('active');
    $(this).parent('div').parent('div').find('.Mobile_inner_child_nav').slideToggle();
});



// Megamenu
$('.hm_nav_img_outer').mouseover(function(){
    $('.hm_nav_img_outer').removeClass('active');
    $(this).addClass('active');
});

$('.hm_nav_img_outer').mouseleave(function(){
    $('.hm_nav_img_outer').removeClass('active');
});

$('.hm_single_links').mouseover(function(){
    $('.hm_single_links').removeClass('active');
    $(this).addClass('active');
});

$('.hm_single_links').mouseleave(function(){
    $('.hm_single_links').removeClass('active');
});

$('.Header_menu_item').mouseover(function(){
    $('.Header_menu_item').removeClass('hovered');
    $(this).addClass('hovered');
    if($(this).hasClass('has_child_items_js')){
        $('.Header_megamenu_container').slideDown();
    }
    else{
        $('.Header_megamenu_container').slideUp();
    }
});

$('.Header_menu_item').mouseleave(function(){
    $('.Header_menu_item').removeClass('hovered');
});

$('.Header_outer ').mouseleave(function(){
    $('.Header_megamenu_container').slideUp();
});



$(document).on("click",'.hm_has_child',function(evt) {
    evt.preventDefault();
    $(this).closest('.hm_mobile_link').find('.hm_mobile_grid_box').slideToggle();
    $(this).toggleClass('opened');
});

// $('.Header_menu_item.has_child_items_js').mouseleave(function(){
//     if ($(this).hasClass('Header_megamenu_container')){

//     }
//     else{
//         $('.Header_megamenu_container').slideUp();
//     }
    
// });